module.exports = __webpack_public_path__ + "src/components/HomeBanner/grid.png?661d5714";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeBanner/grid.png
// module id = 2802
// module chunks = 1